import React, { useState, useEffect } from 'react';
import { LiveKitRoom } from '@livekit/components-react';
import '@livekit/components-styles';
import { VoiceAgent } from './VoiceAgent';

const LIVEKIT_URL = process.env.REACT_APP_LIVEKIT_URL || 'ws://localhost:7880';
const TOKEN       = process.env.REACT_APP_LK_TOKEN    || '';

export default function App() {
  if (!TOKEN) return (
    <div style={{
      height:'100vh', display:'flex', alignItems:'center',
      justifyContent:'center', background:'#0a0a0a', color:'#6b7280',
      fontFamily:'sans-serif', flexDirection:'column', gap:12,
    }}>
      <div style={{ fontSize:'2rem' }}>⚠️</div>
      <div>Falta REACT_APP_LK_TOKEN en ui/.env</div>
    </div>
  );

  return (
    <LiveKitRoom
      serverUrl={LIVEKIT_URL}
      token={TOKEN}
      connect={true}
      audio={true}
      video={false}
    >
      <VoiceAgent />
    </LiveKitRoom>
  );
}
